import React from 'react';
import PropTypes from 'prop-types';

const SsoProviderImage = ({ logoUrl = '', logoAltText = '', ...rest }) => {
  if (logoUrl) {
    return <img alt={logoAltText} src={logoUrl} {...rest} />;
  }
};

SsoProviderImage.propTypes = {
  logoUrl: PropTypes.string,
  logoAltText: PropTypes.string,
};

export default SsoProviderImage;
